import React, { Dispatch, SetStateAction } from 'react';
import styled from '../../../components/styled';

import { RichTextField } from '../../../components';

interface CommentActionFieldProps {
  onChange: Dispatch<SetStateAction<string>>;
}

const CommentActionField = ({ onChange }: CommentActionFieldProps) => {
  return (
    <>
      <Description>Comment</Description>
      <View>
        <TextInput
          autoFocus={true}
          placeholder="Please enter any comments"
          onChangeText={onChange}
        />
      </View>
    </>
  );
};

export default CommentActionField;

const Description = styled.Text`
  margin-top: 10px;
  font-weight: 500;
  margin-bottom: 7px;
`;

const View = styled.View`
  flex-direction: row !important;
  align-items: center;
`;

const TextInput = styled(RichTextField)`
  min-height: 200px;
`;
